/**
 * Product Card Variant Selector for Costica Theme
 * Works with existing item-swatch color swatches
 * Adds second option dropdown (Volume/Size/Weight/etc.) functionality
 */

(function () {
    'use strict';

    // Initialize all product cards on page load
    function initProductCards() {
        const productCards = document.querySelectorAll('[data-product-id^="product-"]');

        productCards.forEach(function (card) {
            const productId = card.getAttribute('data-product-id').replace('product-', '');
            initVariantSelector(productId, card);
        });
    }

    // Initialize variant selector for a specific product
    function initVariantSelector(productId, card) {
        const variantDataElement = card.querySelector('[data-variant-data-' + productId + ']');

        if (!variantDataElement) {
            console.warn('Variant data not found for product:', productId);
            return;
        }

        let variantData;
        try {
            variantData = JSON.parse(variantDataElement.textContent);
        } catch (e) {
            console.error('Failed to parse variant data for product:', productId, e);
            return;
        }

        const variants = variantData.variants;
        const hasColorOption = variantData.hasColorOption;
        const hasSecondOption = variantData.hasSecondOption;
        const colorOptionIndex = variantData.colorOptionIndex;
        const secondOptionIndex = variantData.secondOptionIndex;

        // Get elements
        const existingColorSwatches = card.querySelectorAll('.item-swatch label'); // Costica's color swatches
        const variantOptionDropdowns = card.querySelectorAll('.variant-option-dropdown'); // Dropdowns for size/volume
        const variantIdInput = card.querySelector('[data-variant-id-' + productId + ']');
        const addToCartBtn = card.querySelector('[data-add-to-cart-' + productId + ']');
        const priceWrapper = card.querySelector('[data-price-wrapper-' + productId + ']');
        const saveBadge = card.querySelector('[data-save-badge-' + productId + ']');
        const buttonText = card.querySelector('[data-button-text-' + productId + ']');
        const tooltip = card.querySelector('[data-tooltip-' + productId + ']');

        // Track current selections by option index
        let selectedOptions = {};

        // Initialize selected options from checked inputs
        if (existingColorSwatches.length > 0) {
            // Find active/first color swatch
            const activeColorLabel = card.querySelector('.item-swatch label.active, .item-swatch label');
            if (activeColorLabel) {
                const colorValue = activeColorLabel.getAttribute('data-value') || activeColorLabel.getAttribute('data-title');
                if (colorValue) {
                    selectedOptions[colorOptionIndex] = colorValue;
                }
            }
        }

        // Initialize dropdown selections
        variantOptionDropdowns.forEach(function (dropdown) {
            const optionIndex = parseInt(dropdown.getAttribute('data-option-index'));
            selectedOptions[optionIndex] = dropdown.value;
        });

        // Color swatch click handler (Costica's existing swatches)
        existingColorSwatches.forEach(function (label) {
            label.addEventListener('click', function () {
                const colorValue = this.getAttribute('data-value') || this.getAttribute('data-title');
                if (colorValue) {
                    selectedOptions[colorOptionIndex] = colorValue;
                    updateVariantFromOptions(productId, variants, selectedOptions,
                        variantIdInput, addToCartBtn, priceWrapper, saveBadge, buttonText, tooltip);
                }
            });
        });

        // Dropdown change handler for size/volume options
        variantOptionDropdowns.forEach(function (dropdown) {
            dropdown.addEventListener('change', function () {
                const optionIndex = parseInt(this.getAttribute('data-option-index'));
                selectedOptions[optionIndex] = this.value;

                updateVariantFromOptions(productId, variants, selectedOptions,
                    variantIdInput, addToCartBtn, priceWrapper, saveBadge, buttonText, tooltip);
            });
        });
    }

    // Update swatch label styling based on selected state
    function updateSwatchStyling(card) {
        const allOptionInputs = card.querySelectorAll('.variant-option-input');
        allOptionInputs.forEach(function (input) {
            const label = card.querySelector('label[for="' + input.id + '"]');
            if (label) {
                if (input.checked) {
                    label.style.borderColor = '#000';
                    label.style.backgroundColor = '#000';
                    label.style.color = '#fff';
                } else {
                    label.style.borderColor = '#ddd';
                    label.style.backgroundColor = '#fff';
                    label.style.color = '#333';
                }
            }
        });
    }

    // Find variant from selected options object
    function updateVariantFromOptions(productId, variants, selectedOptions,
        variantIdInput, addToCartBtn, priceWrapper, saveBadge, buttonText, tooltip) {

        // Find matching variant
        const matchedVariant = variants.find(function (variant) {
            // Check if all selected options match this variant
            for (let optionIndex in selectedOptions) {
                if (variant.options[optionIndex] !== selectedOptions[optionIndex]) {
                    return false;
                }
            }
            return true;
        });

        if (!matchedVariant) {
            console.warn('No matching variant found for:', selectedOptions);
            return;
        }

        console.log('Selected variant:', matchedVariant.id, matchedVariant.title, 'Available:', matchedVariant.available);

        // Update hidden variant ID input
        if (variantIdInput) {
            variantIdInput.value = matchedVariant.id;
        }

        // Update button state and text
        if (addToCartBtn && buttonText) {
            if (matchedVariant.available) {
                addToCartBtn.removeAttribute('disabled');
                addToCartBtn.classList.remove('disabled');

                if (matchedVariant.inventory_policy === 'continue' &&
                    matchedVariant.inventory_management === 'shopify' &&
                    matchedVariant.inventory_quantity <= 0) {
                    buttonText.textContent = getTranslation('pre_order');
                    if (tooltip) tooltip.textContent = getTranslation('pre_order');
                } else {
                    buttonText.textContent = getTranslation('add_to_cart');
                    if (tooltip) tooltip.textContent = getTranslation('add_to_cart');
                }
            } else {
                addToCartBtn.setAttribute('disabled', 'disabled');
                addToCartBtn.classList.add('disabled');
                buttonText.textContent = getTranslation('sold_out');
                if (tooltip) tooltip.textContent = getTranslation('sold_out');
            }
        }

        // Update price
        if (priceWrapper) {
            updatePrice(matchedVariant, priceWrapper);
        }

        // Update save badge
        if (saveBadge && matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
            const savedAmount = matchedVariant.compare_at_price - matchedVariant.price;
            saveBadge.innerHTML = 'You save ' + formatMoney(savedAmount) + ' on this order';
            saveBadge.style.display = 'block';
        } else if (saveBadge) {
            saveBadge.style.display = 'none';
        }
    }

    // Find matching variant based on color and second option
    function findMatchingVariant(variants, hasColorOption, hasSecondOption, colorIndex, secondOptionIndex, color, secondOption) {
        return variants.find(function (variant) {
            let colorMatch = true;
            let secondOptionMatch = true;

            if (hasColorOption && color) {
                colorMatch = variant.options[colorIndex] === color;
            }

            if (hasSecondOption && secondOption) {
                secondOptionMatch = variant.options[secondOptionIndex] === secondOption;
            }

            return colorMatch && secondOptionMatch;
        });
    }

    // Update variant and UI
    function updateVariant(productId, variants, hasColorOption, hasSecondOption,
        colorIndex, secondOptionIndex, color, secondOption,
        variantIdInput, addToCartBtn, priceWrapper, saveBadge, buttonText, tooltip) {

        const matchedVariant = findMatchingVariant(variants, hasColorOption, hasSecondOption,
            colorIndex, secondOptionIndex, color, secondOption);

        if (!matchedVariant) {
            console.warn('No matching variant found for:', { color: color, secondOption: secondOption });
            return;
        }

        console.log('Selected variant:', matchedVariant.id, matchedVariant.title, 'Available:', matchedVariant.available);

        // Update hidden variant ID input
        if (variantIdInput) {
            variantIdInput.value = matchedVariant.id;
        }

        // Update button state and text
        if (addToCartBtn && buttonText) {
            if (matchedVariant.available) {
                addToCartBtn.removeAttribute('disabled');
                addToCartBtn.classList.remove('disabled');

                if (matchedVariant.inventory_policy === 'continue' &&
                    matchedVariant.inventory_management === 'shopify' &&
                    matchedVariant.inventory_quantity <= 0) {
                    buttonText.textContent = getTranslation('pre_order');
                    if (tooltip) tooltip.textContent = getTranslation('pre_order');
                } else {
                    buttonText.textContent = getTranslation('add_to_cart');
                    if (tooltip) tooltip.textContent = getTranslation('add_to_cart');
                }
            } else {
                addToCartBtn.setAttribute('disabled', 'disabled');
                addToCartBtn.classList.add('disabled');
                buttonText.textContent = getTranslation('sold_out');
                if (tooltip) tooltip.textContent = getTranslation('sold_out');
            }
        }

        // Update price
        if (priceWrapper) {
            updatePrice(matchedVariant, priceWrapper);
        }

        // Update save badge
        if (saveBadge && matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
            const savedAmount = matchedVariant.compare_at_price - matchedVariant.price;
            saveBadge.innerHTML = 'You save ' + formatMoney(savedAmount) + ' on this order';
            saveBadge.style.display = 'block';
        } else if (saveBadge) {
            saveBadge.style.display = 'none';
        }
    }

    // Update price display
    function updatePrice(variant, priceWrapper) {
        const priceElement = priceWrapper.querySelector('[data-price-grid]');
        const comparePriceElement = priceWrapper.querySelector('[data-compare-price-grid]');

        if (!priceElement) return;

        const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;

        if (isOnSale) {
            // Update to sale layout
            priceWrapper.innerHTML = `
        <div class="price-sale d-inline-flex flex-wrap align-items-center">
          <span class="special-price" data-price-grid>${formatMoney(variant.price)}</span>
          <span class="old-price" data-compare-price-grid>${formatMoney(variant.compare_at_price)}</span>
        </div>
      `;
        } else {
            // Update to regular layout
            priceWrapper.innerHTML = `
        <div class="price-regular">
          <span data-price-grid>${formatMoney(variant.price)}</span>
        </div>
      `;
        }
    }

    // Format money using Shopify's method if available
    function formatMoney(cents) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}');
        }

        // Fallback formatting
        const dollars = (cents / 100).toFixed(2);
        return '$' + dollars;
    }

    // Get translations
    function getTranslation(key) {
        const translations = {
            'add_to_cart': 'Add to Cart',
            'sold_out': 'Sold Out',
            'pre_order': 'Pre-Order'
        };

        // Check if theme has translations
        if (typeof window.theme !== 'undefined' && window.theme.strings && window.theme.strings[key]) {
            return window.theme.strings[key];
        }

        return translations[key] || key;
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initProductCards);
    } else {
        initProductCards();
    }

    // Re-initialize when new products are loaded
    if (typeof window.Shopify !== 'undefined') {
        document.addEventListener('shopify:section:load', initProductCards);
    }

    // Expose for manual initialization
    window.initProductCardVariants = initProductCards;

})();